import { useEffect } from "react";
import { IData } from "../../../../api/modelAPI/detectedSensitiveWordLog";

type Props = {
    item: IData,
    setStates: Function,
    changeStatus: Function,
    loading:boolean
};
const BlockUser = ({ item,setStates,changeStatus, loading}: Props) => {

  
    const setBlock = () => {
        let obj = {
            id: item?.id,
            state: "Block",
            description: ""
        }
        changeStatus(obj)
    }

  return (
    <div>
    <label>آیا از مسدود کردن این کاربر مطمئن هستید؟</label>
    <div className="d-flex justify-content-center align-items-center footer-wrapper ">
        <div className="d-flex justify-content-between align-items-center  mt-3">
            <button className="btn btn-primary" onClick={() => setBlock()}>
                {loading ?
                    <div className="spinner-border" role="status" aria-hidden="true"></div>
                    : 'بله'}
            </button>
            <button className="btn btn-default" onClick={() => setStates({ show: false })}>خیر</button>
        </div>
    </div>
</div>
  );
};
export default BlockUser;
